var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.gridInfo.opts.pagination)?_c('div',{staticClass:"ur-data-grid__pager"},[_c('ur-pagination',{attrs:{"pagination":_vm.gridInfo.pager,"simple":_vm.gridInfo.opts.simplePagination},on:{"move":_vm.onPageMove}})],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }